// Chakra Imports
import {
  Box,
  Flex,
  Text,
  Image,
  useColorModeValue,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  SimpleGrid,
  DrawerOverlay,
} from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import dayjs from "dayjs";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import { HSeparator } from '../../../../components/separator/Separator';
import ConfiguratorLogo from '../../../../assets/img/layout/ConfiguratorLogo.png';
// import { createUserAccess } from '../hooks';
import { LoadingSpinner } from '../../../../constants/helper';
import { getLuggageById } from '../hooks';
import Information from './Information';
// import Dropzone from './Dropzone';

export default function ViewLuggage(props) {
  const { setOpenViewLuggagage, openViewLuggagage, luggageId} = props;
  const [loading, setLoading] = useState(false);

  // Chakra Color Mode
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const bgSeparator = useColorModeValue('secondaryGray.400', '#323B5D');
  const drawerBg = useColorModeValue('white', 'navy.800');

  const configuratorShadow = useColorModeValue(
    '-20px 17px 40px 4px rgba(112, 144, 176, 0.18)',
    '-22px 32px 51px 4px #0B1437',
  );

  const [values, setValues] = useState();

  useEffect(() => {
      const fetchLuggage = async () => {
        setLoading(true);
        try {
            let res = await getLuggageById(luggageId);
            if (res.success) {
                let luggage = res.data;
                setValues(luggage);
            }
        } catch (error) {
            console.error("Error fetching luggages:", error);
        } finally {
            setLoading(false); // Set loading to false after fetching is complete
        }
      };

      fetchLuggage(); // Call the async function
  }, [luggageId]);

  return (
    <>
      <Drawer
        isOpen={openViewLuggagage}
        onClose={() => setOpenViewLuggagage(false)}
        placement={document.documentElement.dir === 'rtl' ? 'left' : 'right'}
        blockScrollOnMount={false}
      >
        <DrawerOverlay />
        <DrawerContent
          boxShadow={configuratorShadow}
          w={{ base: 'calc(100vw - 32px)', md: '400px' }}
          maxW={{ base: 'calc(100vw - 32px)', md: '400px' }}
          ms={{
            base: '0px',
            sm: '16px',
          }}
          me={{
            base: '16px',
          }}
          my={{
            sm: '16px',
          }}
          borderRadius="16px"
          bg={drawerBg}
        >
          {loading ? <LoadingSpinner /> : 
        <>
          <DrawerHeader
            w={{ base: '100%', md: '400px' }}
            pt="24px"
            pb="0px"
            px="24px"
          >
            <DrawerCloseButton color={textColor} />
            <Flex alignItems="center">
              <Flex
                h="48px"
                w="48px"
                me="20px"
                borderRadius="999px"
                bgGradient="linear(to-b, brand.400, brand.600)"
              >
                <Image src={ConfiguratorLogo} />
              </Flex>
              <Box>
                <Text color={textColor} fontSize="xl" fontWeight="700">
                 Luggage Details
                </Text>
              </Box>
            </Flex>
            <HSeparator my="30px" bg={bgSeparator} />
          </DrawerHeader>
          <DrawerBody
            pt="0px"
            pb="24px"
            w={{ base: '100%', md: '400px' }}
            maxW="unset"
          >
             {values?.imageUrls && values.imageUrls.length > 0 ? (
              <Box mb="20px" position="relative">
                <Swiper
                  pagination={{
                    clickable: true,
                    el: ".custom-swiper-pagination",
                  }}
                  navigation={{
                    nextEl: ".custom-swiper-next",
                    prevEl: ".custom-swiper-prev",
                  }}
                  modules={[Pagination, Navigation]}
                  spaceBetween={10}
                  slidesPerView={1}
                  style={{ borderRadius: '16px', overflow: 'hidden' }}
                >
                  {values?.imageUrls?.map((url, index) => (
                    <SwiperSlide key={index}>
                      <Image
                        src={url}
                        alt={`Luggage image ${index + 1}`}
                        borderRadius="16px"
                        objectFit="cover"
                        w="100%"
                        h="250px"
                        cursor="pointer"
                        _hover={{
                          transform: "scale(1.02)",
                          transition: "all 0.2s ease-in-out",
                        }}
                        onClick={() => window.open(url, "_blank")}
                      />
                    </SwiperSlide>
                  ))}

                  {/* Custom navigation buttons */}
                  <Box
                    className="custom-swiper-prev"
                    position="absolute"
                    top="50%"
                    left="10px"
                    transform="translateY(-50%)"
                    zIndex="10"
                    cursor="pointer"
                    color="black"
                    fontSize="24px"
                    _hover={{ color: "gray.600" }}
                  >
                    &#10094;
                  </Box>
                  <Box
                    className="custom-swiper-next"
                    position="absolute"
                    top="50%"
                    right="10px"
                    transform="translateY(-50%)"
                    zIndex="10"
                    cursor="pointer"
                    color="black"
                    fontSize="24px"
                    _hover={{ color: "gray.600" }}
                  >
                    &#10095;
                  </Box>
                </Swiper>

                {/* Pagination dots container BELOW the image */}
                <Box className="custom-swiper-pagination" mt="10px" textAlign="center" />
              </Box>

            ) : null}
            <Flex direction="column" w="100%" mt="20px">
            <SimpleGrid columns='2' gap='20px'>
              {values?.createdAt && <Information title='Created On' value={dayjs(values?.createdAt).format("DD MMM YYYY, hh:mm A")} />}
              {values?.airlineName && <Information title='Airline Name' value={values?.airlineName} />}
              {values?.luggageStatus && <Information title='Luggage Status' value={values?.luggageStatus} />}
              {values?.referenceNumber && <Information title='Reference Number' value={values?.referenceNumber} />}
              {values?.noOfBags && <Information title='No. Of Bags' value={values?.noOfBags} />}
              {values?.carrierName && <Information title='Carrier Name' value={values?.carrierName} />}
              {values?.notes && <Information title='Notes' value={values?.notes} />}
            </SimpleGrid>
            <HSeparator my="30px" bg={bgSeparator} />
            <SimpleGrid columns='2' gap='20px'>
              {values?.luggageStatus && values?.luggageStatus === "Delivered" && values?.updatedAt && <Information title='Delivered On' value={dayjs(values?.updatedAt).format("DD MMM YYYY, hh:mm A")} />}
              {values?.customerName && <Information title='Customer Name' value={values?.customerName} />}
              {values?.customerPhoneNumber !== "null" ? <Information title='Customer Number' value={values?.customerPhoneNumber} /> : null} 
              {values?.recipientName && <Information title='Recipient Name' value={values?.recipientName} />}
              {values?.recipientPhoneNumber && <Information title='Recipient Number' value={values?.recipientPhoneNumber} />} 
            </SimpleGrid>
            </Flex>
          </DrawerBody>
          </>
        }   
        </DrawerContent>
      </Drawer>
    </>
  );
}
